export default (theme) => ({
  welcome: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '40%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    userSelect: 'none',
  },
  formWelcome: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  header: {
    fontWeight: 'bold',
    fontSize: 45,
    userSelect: 'none',
    [theme.breakpoints.down('xl')]: {
      fontSize: 36,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 45,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  logoIcon: {
    objectFit: 'contain',
    objectPosition: 'center',
    width: 100,
    height: 100,
    [theme.breakpoints.down('xl')]: {
      width: 90,
      height: 90,
    },
    [theme.breakpoints.down('sm')]: {
      width: 76,
      height: 76,
    },
  },
});
